// extracted by mini-css-extract-plugin
export default {"options":"CourseOptions_options__NYT36"};